import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MeetingService } from 'src/app/service/meeting.service';

export interface TeamsSyncDialogData {
  sourceMeeting: any; // the item passed from onSync
  candidates: Array<{ _id: number; meetingDate: string; meetingTitle: string }>; // sample data
}

@Component({
  selector: 'app-teams-sync-results-dialog',
  templateUrl: './teams-sync-results-dialog.component.html',
  styleUrls: ['./teams-sync-results-dialog.component.css']
})
export class TeamsSyncResultsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TeamsSyncResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TeamsSyncDialogData,
    private meetingService: MeetingService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  createFromCandidate(candidate: { _id: number; meetingDate: string; meetingTitle: string }): void {
    const payload = {
      source: this.data.sourceMeeting,
      candidate,
    };
    // Placeholder: call a service - using searchMeeting as a stand-in
    this.meetingService.searchMeeting(payload).subscribe({
      next: (resp) => {
        console.log('Create from candidate response:', resp);
        this.dialogRef.close({ created: true, candidate });
      },
      error: (err) => {
        console.error('Create from candidate failed:', err);
      },
    });
  }

  createNew(): void {
    // const payload = {
    //   source: this.data.sourceMeeting,
    //   candidate: null,
    // };
    console.log("selected data : ",this.data.sourceMeeting);
    const payload = {
      "meetingDateStr": "Jan 09, 2026",
      "meetingStartTime": "19:15",
      "orgCode": "CHN",
      "userId": 154,
      "visitorTimeZone": "Asia/Kolkata",
      "duration": 60,
      "logType": "IN",
      "meetingTitle": "auto created",
      "eventId" : this.data.sourceMeeting,
      "meetingStartDate":"",
      "meetingEndDate":""
  }
    // Placeholder: call a service - using searchMeeting as a stand-in
    this.meetingService.createNewMeeting(payload).subscribe({
      next: (resp) => {
        console.log('Create new meeting response:', resp);
        this.dialogRef.close({ created: true, candidate: null });
      },
      error: (err) => {
        console.error('Create new meeting failed:', err);
      },
    });
  }
}
